<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
@import './assets/scss/front';
</style>



// WEBPACK FOOTER //
// App.vue?ab91a8ec